/* eslint-disable */
import React from 'react';
import SEO from './SEO';
import './styles/styles.css';

const containerStyle = {
  minHeight: '60vh',
  backgroundColor: '#FFF',
  padding: '4rem 2rem',
  fontFamily: 'Raleway, sans-serif',
};

const innerStyle = {
  maxWidth: 760,
  margin: '0 auto',
};

const h1Style = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '2.25rem',
  fontWeight: 700,
  color: '#261136',
  marginBottom: '0.25rem',
};

const metaStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.9rem',
  color: '#888',
  marginBottom: '2.5rem',
};

const h2Style = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1.3rem',
  fontWeight: 700,
  color: '#261136',
  marginTop: '2rem',
  marginBottom: '0.5rem',
};

const pStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.97rem',
  color: '#444',
  lineHeight: 1.7,
  marginBottom: '0.75rem',
};

const PublicPrivacy = () => (
  <>
    <SEO
      title="Privacy Policy | Bins Storage"
      description="Read the Bins Storage privacy policy – how we collect, use, and protect your personal information."
      path="/privacy"
    />
    <div style={containerStyle}>
      <div style={innerStyle}>
        <h1 style={h1Style}>Privacy Policy</h1>
        <p style={metaStyle}>Last updated: April 1, 2022</p>

        <p style={pStyle}>
          This Privacy Policy describes how Bins Storage, Inc. ("Bins," "we," "us," or
          "our") collects, uses, and shares information about you when you use our
          website and services.
        </p>

        <h2 style={h2Style}>Information We Collect</h2>
        <p style={pStyle}>
          We collect information you provide directly to us (name, email, phone,
          address), information collected automatically when you use our services
          (device data, IP address, pages visited, time spent), and information from
          third-party services you connect to your account.
        </p>

        <h2 style={h2Style}>How We Use Your Information</h2>
        <p style={pStyle}>
          We use your information to provide and improve our services, communicate
          with you about your account and orders, send promotional communications
          (with your consent), comply with legal obligations, and prevent fraud and
          abuse.
        </p>

        <h2 style={h2Style}>Sharing of Information</h2>
        <p style={pStyle}>
          We do not sell your personal information. We share your information with
          storage facility partners (to fulfill your order), service providers who
          assist our operations, and when required by law.
        </p>

        <h2 style={h2Style}>Data Retention</h2>
        <p style={pStyle}>
          We retain your personal data for as long as necessary to provide services
          and comply with legal obligations. You may request deletion of your account
          data at any time by contacting us.
        </p>

        <h2 style={h2Style}>Your Rights</h2>
        <p style={pStyle}>
          Depending on your jurisdiction, you may have rights to access, correct,
          delete, or port your personal data. To exercise these rights, contact us at{' '}
          <a href="mailto:contact@bins-storage.com" style={{ color: '#7B1FA2' }}>
            contact@bins-storage.com
          </a>.
        </p>

        <h2 style={h2Style}>Cookies</h2>
        <p style={pStyle}>
          We use cookies and similar technologies to operate our website and analyze
          traffic. You can control cookies through your browser settings.
        </p>

        <h2 style={h2Style}>Children's Privacy</h2>
        <p style={pStyle}>
          Our services are not directed to children under 13. We do not knowingly
          collect personal information from children under 13.
        </p>

        <h2 style={h2Style}>Changes to This Policy</h2>
        <p style={pStyle}>
          We may update this Privacy Policy from time to time. We will notify you of
          material changes by posting the updated policy on this page and updating
          the "Last updated" date.
        </p>

        <h2 style={h2Style}>Contact Us</h2>
        <p style={pStyle}>
          Bins Storage, Inc.<br />
          Email:{' '}
          <a href="mailto:contact@bins-storage.com" style={{ color: '#7B1FA2' }}>
            contact@bins-storage.com
          </a>
        </p>
      </div>
    </div>
  </>
);

export default PublicPrivacy;
